const autoSAR = {
    namespaced: true,
    mutations: {
        updateAutoSAR(state, v) {
            state.autoSAR = v;
        }
    },
    state: {
        lin_config: {
            properties: {
                Lin_channel_num: 3,
                Lin_unified_interrupts: true,
                Lin_precompile_support: false,
                Lin_dual_lock_mode: false
            },
            version_cfg: {
                autosar_major_version: 4,
                autosar_minor_version: 2,
                autosar_release_revision_version: 2,
                numeric_module_id: 82,
                softerware_major_version: 0,
                softerware_minor_version: 0,
                softerware_patch_version: 1,
                vendor_id: 43,
                vendor_api_id: 43
            },
            non_autosar: {
                lin_disable_production_error_reporting: true,
                lin_disable_frame_timeout: true
            },
            general_cfg: {
                lin_default_error_detection: true,
                instace_id: 0,
                lin_timeout_duration: 65535,
                lin_versioninfo_api: true,
                linclockref_alternate: true
            },
            dem_params: {
                lin_dem_event_parameter_refs: true,
                lin_timeout_dem_error: "path",
                lin_disable_dem_report_error_support: false
            },

            channel_cfg: [
                {
                    index: 0,
                    name: "LinChannel_0",
                    lin_chn_id: 0,
                    lin_chn_baurd: 9600,
                    break_length: "BL_13",
                    lin_hw_chn: "LPUART_0",
                    lin_chn_wakeup_support: true,
                    LinClockRef: "path",
                    ecum_wakeup_source: "path"
                },
                {
                    index: 1,
                    name: "LinChannel_1",
                    lin_chn_id: 1,
                    lin_chn_baurd: 9600,
                    break_length: "BL_13",
                    lin_hw_chn: "LPUART_1",
                    lin_chn_wakeup_support: true,
                    LinClockRef: "path",
                    ecum_wakeup_source: "path"
                }
            ]
        }
    }
}

export default autoSAR;
